module.exports = __webpack_public_path__ + "assets/img/5_1184_big.d20af01e.jpg";